const DOCUMENT = 'UNDO_NCNS_';

const actions = {
  LOAD_FORM: DOCUMENT + 'LOAD_FORM',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  SEND_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  TOUCH: DOCUMENT + 'TOUCH',

  loadForm: data => ({
    type: actions.LOAD_FORM,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  sendSuccess: () => ({
    type: actions.SEND_SUCCESS,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
